// Module
var code = " <div class=\"full-height\"> <header> <h1>Page Title</h1> <p>This is some header text.</p> </header> <div class=\"main-content\"> <div class=\"bigger\">Lots of content: it requires scrolling</div> </div> </div> ";
// Exports
export default code;